import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const CertificationPolicies = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Certification Policies</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) implements certification policies to ensure fair, transparent, and consistent certification practices under its Industrial Research and Training division.
          </p>
          <p className="subtitle">
            These policies guide organizations, products, and personnel through a standardized approach to meet national and international standards.
          </p>
        </div>
      </section>

      {/* === Policies Overview Section === */}
      <section className="intro-section">
        <h2 className="section-title">Key Certification Policies</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Compliance Policy – All certification activities must meet national and international standards</li>
              <li>Impartiality Policy – Certification decisions are made without bias or undue influence</li>
              <li>Confidentiality Policy – Information obtained during certification is treated as confidential</li>
              <li>Integrity Policy – MBS maintains honesty and ethical standards in all certification processes</li>
              <li>Transparency Policy – Certification procedures, requirements, and decisions are transparent</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Non-discrimination Policy – Certification is available to all eligible applicants without discrimination</li>
              <li>Continuous Improvement Policy – Certification processes are regularly reviewed and improved</li>
              <li>Surveillance Policy – Certified organizations are monitored for ongoing compliance</li>
              <li>Appeals Policy – Applicants can appeal decisions through established procedures</li>
              <li>Documentation Policy – All certification activities are properly documented and maintained</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Benefits of Policies Section === */}
      <section className="functions-section">
        <h2 className="section-title">Benefits of Certification Policies</h2>
        <p>
          MBS certification policies ensure fairness, reliability, and credibility in the certification process. They enhance stakeholder confidence, support quality improvement, and promote compliance with national and international standards.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Certification Policies</h2>
        <p>
          For inquiries or more information about MBS certification policies, please contact the Industrial Research and Training Certification team.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:certification@mbs.mw">certification@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 777</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          Certification policies ensure consistency, transparency, and reliability, strengthening the credibility of MBS certification programs in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default CertificationPolicies;
